export var classNames = {
  SMALL: "-small-cards"
};
export var selectors = {
  PAGINATION: ".ef-carousel__pagination",
  PREVBUTTON: ".ef-carousel__btn--prev",
  NEXTBUTTON: ".ef-carousel__btn--next",
  SWIPER: ".swiper-container"
};
export var DATA_KEY = "ef.carousel";